module.exports = __webpack_public_path__ + "static/media/archivo.351c62d3.svg";